import type React from 'react';

import { cn } from '@change/ds-utils';

import { Html } from 'src/app/shared/components/html';

import { END_OF_TRUNCATION_NOISE } from '../../../../../../../../constants';
import type { PreviewEmailContentUpdateProps } from '../../../../../../types';

export const PreviewEmailContentUpdate: React.FC<PreviewEmailContentUpdateProps> = ({ contentHtml, limit }) => {
	const [text, isTruncated] =
		contentHtml.length > limit
			? [contentHtml.substring(0, limit).replace(END_OF_TRUNCATION_NOISE, ''), true]
			: [contentHtml, false];
	return (
		<div className="mb-4 px-4">
			<div className={cn({ "[&_p:last-of-type]:after:content-['…']": isTruncated })}>
				<Html html={text} data-testid="preview-email-update-content" />
			</div>
		</div>
	);
};
